import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { Toaster } from './components/ui/toaster';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import AuthPage from './pages/AuthPage';
import StoryBrowser from './pages/StoryBrowser';
import StoryReader from './pages/StoryReader';
import Training from './pages/Training';
import Profile from './pages/Profile';
import AdminPanel from './pages/AdminPanel';
import GrammarAdmin from './pages/GrammarAdmin';
import WordDatabaseAdmin from './pages/WordDatabaseAdmin';
import StoryGeneratorAdmin from './pages/StoryGeneratorAdmin';
import PricingPage from './pages/PricingPage';
import GrammarPage from './pages/GrammarPage';
import BlogPage from './pages/BlogPage';
import './App.css';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LanguageProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route 
                path="/auth" 
                element={
                  <ProtectedRoute requireAuth={false}>
                    <AuthPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/stories" 
                element={
                  <ProtectedRoute>
                    <StoryBrowser />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/story/:id" 
                element={
                  <ProtectedRoute>
                    <StoryReader />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/training" 
                element={
                  <ProtectedRoute>
                    <Training />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/profile" 
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute>
                    <AdminPanel />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/grammar" 
                element={
                  <ProtectedRoute>
                    <GrammarAdmin />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/words" 
                element={
                  <ProtectedRoute>
                    <WordDatabaseAdmin />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/story-generator" 
                element={
                  <ProtectedRoute>
                    <StoryGeneratorAdmin />
                  </ProtectedRoute>
                } 
              />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/grammar" element={<GrammarPage />} />
              <Route path="/blog" element={<BlogPage />} />
            </Routes>
            <Toaster />
          </BrowserRouter>
        </LanguageProvider>
      </AuthProvider>
    </div>
  );
}

export default App;